import {
  getProfessionForAccount,
  getProfessionLabel,
} from "./userProfession";

export const formatUserForExport = (user = {}) => ({
  ID: user.IdUsuario ?? "",
  Usuario: user.Usuario ?? "",
  Nombre: user.Nombre ?? "",
  CI: user.Cedula ?? "",
  "Profesión": getProfessionLabel(getProfessionForAccount(user)),
  "Registro Profesional":
    user.RegistroProfesional ?? user.registroprofesional ?? "",
  "Fecha de Ingreso": user.Fechaingreso ?? user.Fechadeingreso ?? "",
  Sexo: user.sexo ?? "",
  "Estado Civil": user.estadocivil ?? "",
  Hijos: user.hijos ?? "",
  "Fecha de Nacimiento": user.Fechadenacimiento ?? "",
  "Antecedentes Policiales": user.antpol ?? "",
  Teléfono: user.Telefono ?? "",
  Departamento: user.departamento ?? "",
  Ciudad: user.Ciudad ?? "",
  Barrio: user.barrio ?? "",
  Dirección: user.direccion ?? user.Direccion ?? "",
  "Método de Pago": user.metododepago ?? "",
  Estado: user.estaActivo ?? "",
});

export const formatUsersForExport = (users = []) =>
  users.map(formatUserForExport);
